<template>
  <div class="relative">
    <form ref="form">
      <input
          class="absolute opacity-0 inset-0 cursor-pointer w-full"
          type="file"
          data-test="uploader"
          ref="uploader"
          @change="onAdd"
          :multiple="multiple"
          :accept="accept"
          data-hj-suppress/>
    </form>
    <div
        class="h-full border-dashed border-3 border-primary p-xs cursor-pointer overflow-hidden flex flex-col"
        tabindex="0">
      <slot class="flex-none" name="files" />
      <div class="flex-grow flex flex-col justify-center">
        <div class="text-center mb-base">
          <CloudUploadIcon
            size="3x"
            class="float my-0 mx-auto cursor-pointer"
          />
          <br>
          <b>{{ uploaderMessage }}</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CloudUploadIcon } from '@/components/icons/fontIcons';

export default {
  name: 'TWFilePicker',
  introduction: 'A file picker component which emits selected files.',
  components: {
    CloudUploadIcon,
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
      note: 'Toggles selection of multiple files.',
    },
    accept: {
      type: String,
      note: 'The accepted file type.',
    },
    uploaderMessage: {
      type: String,
      default: 'Click here or drag a file to upload...',
      note: 'The text to show in the content. Should probably be a slot',
    },
  },
  methods: {
    onAdd() {
      const { files } = this.$refs.uploader;

      this.$emit('add', files);

      this.$refs.form.reset();
    },
  },
};
</script>
